<template>
  <div class="cell-date-wrap flex items-center h-full">
    <vs-chip v-if="minutesAgo != null" color="success" class="cell-date-chip">{{ minutesAgo }} min ago</vs-chip>
    <span class="cell-date-value">{{ formattedDate }}</span>
  </div>
</template>

<script>
export default {
  name: "CellRendererDate",
  computed: {
    value() {
      if (!this.params) return null;
      if (this.params.value != null && this.params.value !== "") return this.params.value;
      if (this.params.data && this.params.data.createdAt != null) return this.params.data.createdAt;
      return null;
    },
    formattedDate() {
      if (!this.value) return "—";
      const d = new Date(this.value);
      return d.toLocaleDateString("en-GB", { dateStyle: "short" }) + " " + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    },
    minutesAgo() {
      if (!this.value) return null;
      const d = new Date(this.value);
      const now = new Date();
      const diffMs = now - d;
      const diffMins = Math.floor(diffMs / 60000);
      return diffMins >= 0 ? diffMins : 0;
    },
  },
};
</script>

<style scoped>
.cell-date-wrap {
  gap: 0.5rem;
  flex-wrap: wrap;
}
.cell-date-value {
  white-space: nowrap;
}
.cell-date-chip {
  font-size: 0.7rem;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem !important;
  min-height: auto !important;
  line-height: 1.2;
}
</style>
